// GENERATED by tools/gen-font-protrusion.mjs from microtype's config
// sources (microtype.dtx, docstrip module cfg-t) — do not edit by hand.
// Each table is a hand-tuned per-font protrusion config from the microtype
// package, in thousandths of the glyph advance (pdfTeX semantics), exactly
// as its named contributors tuned it by eye. Fonts without a table here
// fall back to the generic `latinProtrusion`, as TeX itself does.
import type { ProtrusionTable } from './types.js';

const TABLES: Record<string, ProtrusionTable> = {
  // EB Garamond (Duffner/Pardo; mt-ebg by R. Schlicht et al.)
  ebg: {
    "1": { l: 50, r: 50 },
    "2": { l: 50, r: 50 },
    "4": { l: 50, r: 50 },
    "7": { l: 50, r: 50 },
    "A": { l: 50, r: 50 },
    "Æ": { l: 50 },
    "C": { l: 50 },
    "D": { r: 50 },
    "F": { r: 50 },
    "G": { l: 50 },
    "J": { l: 50 },
    "K": { r: 50 },
    "L": { r: 50 },
    "O": { l: 50, r: 50 },
    "Œ": { l: 50 },
    "Q": { l: 50, r: 70 },
    "R": { r: 70 },
    "T": { l: 70, r: 70 },
    "V": { l: 50, r: 50 },
    "W": { l: 50, r: 50 },
    "X": { l: 50, r: 50 },
    "Y": { l: 50, r: 50 },
    "k": { r: 50 },
    "p": { r: 50 },
    "q": { l: 50 },
    "r": { r: 50 },
    "t": { r: 70 },
    "v": { l: 50, r: 50 },
    "w": { l: 50, r: 50 },
    "x": { l: 50, r: 50 },
    "y": { r: 50 },
    ".": { r: 600 },
    ",": { r: 500 },
    ":": { r: 400 },
    ";": { r: 300 },
    "!": { r: 100 },
    "?": { r: 100 },
    "@": { l: 50, r: 50 },
    "~": { l: 200, r: 250 },
    "&": { l: 50, r: 100 },
    "%": { l: 50, r: 50 },
    "*": { l: 300, r: 300 },
    "+": { l: 250, r: 250 },
    "(": { l: 100 },
    ")": { r: 200 },
    "/": { l: 100, r: 200 },
    "-": { l: 300, r: 500 },
    "–": { l: 300, r: 300 },
    "—": { l: 200, r: 200 },
    "‘": { l: 300, r: 500 },
    "’": { l: 400, r: 400 },
    "“": { l: 300, r: 300 },
    "”": { l: 300, r: 300 },
    "_": { l: 100, r: 100 },
    "\\": { l: 100, r: 200 },
    "‚": { l: 400, r: 400 },
    "„": { l: 400, r: 400 },
    "‹": { l: 400, r: 400 },
    "›": { l: 300, r: 500 },
    "«": { l: 300, r: 300 },
    "»": { l: 200, r: 300 },
    "¡": { l: 100 },
    "¿": { l: 100 },
    "{": { l: 400, r: 200 },
    "}": { l: 200, r: 400 },
    "<": { l: 200, r: 100 },
    ">": { l: 100, r: 200 },
  },

  // Palatino (mt-ppl)
  ppl: {
    "1": { l: 100, r: 100 },
    "7": { r: 50 },
    "A": { l: 50, r: 50 },
    "J": { l: 50 },
    "K": { r: 50 },
    "L": { r: 50 },
    "T": { l: 50, r: 50 },
    "V": { l: 50, r: 50 },
    "W": { l: 50, r: 50 },
    "X": { l: 50, r: 50 },
    "Y": { l: 50, r: 50 },
    "k": { r: 50 },
    "p": { l: 50, r: 50 },
    "q": { l: 50 },
    "r": { r: 50 },
    "v": { l: 50, r: 50 },
    "w": { l: 50, r: 50 },
    "x": { l: 50, r: 50 },
    "y": { l: 50, r: 70 },
    ".": { r: 700 },
    ",": { r: 500 },
    ":": { r: 500 },
    ";": { r: 500 },
    "!": { r: 100 },
    "?": { r: 200 },
    "@": { l: 50, r: 50 },
    "~": { l: 200, r: 250 },
    "&": { l: 50, r: 100 },
    "%": { l: 100, r: 100 },
    "*": { l: 200, r: 200 },
    "+": { l: 250, r: 250 },
    "(": { l: 100 },
    ")": { r: 300 },
    "/": { l: 200, r: 300 },
    "-": { l: 400, r: 500 },
    "–": { l: 300, r: 300 },
    "—": { l: 200, r: 200 },
    "‘": { l: 500, r: 700 },
    "’": { l: 500, r: 700 },
    "“": { l: 300, r: 400 },
    "”": { l: 300, r: 400 },
    "_": { l: 100, r: 100 },
    "\\": { l: 200, r: 300 },
    "‚": { l: 400, r: 400 },
    "„": { l: 400, r: 400 },
    "‹": { l: 400, r: 400 },
    "›": { l: 300, r: 500 },
    "«": { l: 300, r: 300 },
    "»": { l: 200, r: 400 },
    "¡": { l: 100 },
    "¿": { l: 100 },
    "{": { l: 400, r: 200 },
    "}": { l: 200, r: 400 },
    "<": { l: 200, r: 100 },
    ">": { l: 100, r: 200 },
  },

  // Times (mt-ptm)
  ptm: {
    "1": { l: 150, r: 150 },
    "4": { l: 70 },
    "7": { l: 50, r: 100 },
    "A": { l: 50, r: 50 },
    "Æ": { l: 50 },
    "F": { r: 50 },
    "J": { l: 50 },
    "K": { r: 50 },
    "L": { r: 80 },
    "T": { l: 50, r: 50 },
    "V": { l: 50, r: 50 },
    "W": { l: 50, r: 50 },
    "X": { l: 50, r: 50 },
    "Y": { l: 80, r: 80 },
    "k": { r: 50 },
    "r": { r: 50 },
    "v": { l: 50, r: 50 },
    "w": { l: 50, r: 50 },
    "x": { l: 50, r: 50 },
    "y": { l: 50, r: 70 },
    ".": { r: 700 },
    ",": { r: 500 },
    ":": { r: 500 },
    ";": { r: 300 },
    "!": { r: 100 },
    "?": { r: 100 },
    "@": { l: 100, r: 100 },
    "~": { l: 200, r: 250 },
    "&": { l: 50, r: 100 },
    "%": { l: 100, r: 100 },
    "*": { l: 200, r: 200 },
    "+": { l: 250, r: 250 },
    "(": { l: 100 },
    ")": { r: 200 },
    "/": { l: 100, r: 200 },
    "-": { l: 500, r: 500 },
    "–": { l: 300, r: 300 },
    "—": { l: 200, r: 200 },
    "‘": { l: 500, r: 500 },
    "’": { l: 300, r: 500 },
    "“": { l: 300, r: 400 },
    "”": { l: 300, r: 400 },
    "_": { l: 100, r: 100 },
    "\\": { l: 100, r: 200 },
    "‚": { l: 400, r: 400 },
    "„": { l: 400, r: 400 },
    "‹": { l: 400, r: 400 },
    "›": { l: 300, r: 500 },
    "«": { l: 300, r: 300 },
    "»": { l: 200, r: 400 },
    "¡": { l: 200 },
    "¿": { l: 200 },
    "{": { l: 400, r: 200 },
    "}": { l: 200, r: 400 },
    "<": { l: 200, r: 100 },
    ">": { l: 100, r: 200 },
  },

  // Bitstream Charter (mt-bch)
  bch: {
    "1": { l: 150, r: 150 },
    "2": { l: 50, r: 50 },
    "3": { l: 50 },
    "4": { l: 100, r: 50 },
    "6": { l: 50 },
    "7": { l: 50, r: 80 },
    "9": { l: 50, r: 50 },
    "A": { l: 50, r: 50 },
    "C": { l: 50 },
    "D": { r: 50 },
    "F": { r: 50 },
    "G": { l: 50 },
    "J": { l: 100 },
    "K": { r: 50 },
    "L": { r: 50 },
    "O": { l: 50, r: 50 },
    "Q": { l: 50, r: 70 },
    "R": { r: 50 },
    "T": { l: 50, r: 50 },
    "V": { l: 50, r: 50 },
    "W": { l: 50, r: 50 },
    "X": { l: 50, r: 50 },
    "Y": { l: 50, r: 50 },
    "k": { r: 50 },
    "r": { r: 50 },
    "t": { r: 50 },
    "v": { l: 50, r: 50 },
    "w": { l: 50, r: 50 },
    "x": { l: 50, r: 50 },
    "y": { r: 50 },
    ".": { r: 600 },
    ",": { r: 500 },
    ":": { r: 400 },
    ";": { r: 300 },
    "!": { r: 100 },
    "?": { r: 200 },
    "@": { l: 50, r: 50 },
    "~": { l: 200, r: 250 },
    "%": { r: 50 },
    "*": { l: 200, r: 300 },
    "+": { l: 150, r: 250 },
    "(": { l: 200 },
    ")": { r: 200 },
    "[": { l: 100 },
    "]": { r: 100 },
    "/": { r: 200 },
    "-": { l: 400, r: 500 },
    "–": { l: 200, r: 300 },
    "—": { l: 150, r: 250 },
    "‘": { l: 300, r: 400 },
    "’": { l: 300, r: 400 },
    "“": { l: 300, r: 300 },
    "”": { l: 300, r: 300 },
    "Œ": { l: 50 },
    "_": { l: 100, r: 100 },
    "\\": { l: 150, r: 200 },
    "‚": { l: 400, r: 400 },
    "„": { l: 300, r: 300 },
    "‹": { l: 400, r: 300 },
    "›": { l: 300, r: 400 },
    "«": { l: 200, r: 200 },
    "»": { l: 150, r: 300 },
    "¡": { l: 100 },
    "¿": { l: 100 },
    "{": { l: 200 },
    "}": { r: 300 },
    "<": { l: 200, r: 100 },
    ">": { l: 100, r: 200 },
  },

  // Adobe Minion (mt-pmn by H. Harders & K. Karlsson)
  pmn: {
    "1": { r: 50 },
    "3": { l: 50 },
    "4": { l: 50 },
    "7": { l: 50, r: 80 },
    "A": { l: 50, r: 50 },
    "C": { l: 50 },
    "D": { r: 50 },
    "F": { r: 50 },
    "G": { l: 50 },
    "J": { l: 50 },
    "K": { r: 50 },
    "L": { r: 50 },
    "O": { l: 50, r: 50 },
    "Q": { l: 50, r: 70 },
    "T": { l: 50, r: 50 },
    "V": { l: 50, r: 50 },
    "W": { l: 50, r: 50 },
    "X": { l: 50, r: 50 },
    "Y": { l: 50, r: 50 },
    "k": { r: 50 },
    "l": { r: -50 },
    "r": { r: 50 },
    "t": { r: 70 },
    "v": { l: 50, r: 50 },
    "w": { l: 50, r: 50 },
    "x": { l: 50, r: 50 },
    "y": { r: 50 },
    ".": { r: 700 },
    ",": { r: 500 },
    ":": { r: 500 },
    ";": { r: 300 },
    "!": { r: 100 },
    "?": { r: 100 },
    "\"": { l: 300, r: 300 },
    "@": { l: 50, r: 50 },
    "~": { l: 200, r: 250 },
    "%": { l: 50, r: 50 },
    "*": { l: 200, r: 300 },
    "+": { l: 150, r: 200 },
    "(": { l: 100 },
    ")": { r: 200 },
    "[": { l: 100 },
    "]": { r: 100 },
    "/": { l: 100, r: 200 },
    "-": { l: 200, r: 400 },
    "–": { l: 200, r: 200 },
    "—": { l: 150, r: 150 },
    "‘": { l: 300, r: 400 },
    "’": { l: 300, r: 400 },
    "“": { l: 300, r: 300 },
    "”": { l: 300, r: 300 },
    "Œ": { l: 50 },
    "_": { l: 100, r: 100 },
    "\\": { l: 100, r: 200 },
    "‚": { l: 400, r: 400 },
    "„": { l: 300, r: 300 },
    "‹": { l: 400, r: 300 },
    "›": { l: 300, r: 400 },
    "«": { l: 200, r: 200 },
    "»": { l: 150, r: 300 },
    "¡": { l: 100 },
    "¿": { l: 100 },
    "{": { l: 200 },
    "}": { r: 300 },
    "<": { l: 100 },
    ">": { r: 100 },
  },

  // URW Garamond (mt-ugm) — also matched for other Garamond cuts (all Garaldes)
  ugm: {
    "1": { l: 150, r: 150 },
    "2": { l: 50, r: 50 },
    "3": { l: 50, r: 50 },
    "4": { l: 70, r: 70 },
    "7": { l: 50, r: 80 },
    "A": { l: 50, r: 100 },
    "Æ": { l: 150, r: 50 },
    "B": { r: 50 },
    "C": { l: 50 },
    "D": { r: 70 },
    "E": { r: 50 },
    "F": { r: 70 },
    "G": { l: 50, r: 50 },
    "J": { l: 50 },
    "K": { r: 50 },
    "L": { r: 120 },
    "O": { l: 50, r: 50 },
    "Œ": { l: 50, r: 50 },
    "P": { r: 50 },
    "Q": { l: 50, r: 50 },
    "R": { r: 70 },
    "T": { l: 70, r: 70 },
    "V": { l: 70, r: 70 },
    "W": { l: 70, r: 70 },
    "X": { l: 50, r: 70 },
    "Y": { l: 80, r: 80 },
    "Z": { l: 50, r: 50 },
    "k": { r: 70 },
    "p": { r: 50 },
    "r": { r: 50 },
    "t": { r: 100 },
    "v": { l: 50, r: 70 },
    "w": { l: 50, r: 70 },
    "x": { l: 50, r: 50 },
    "y": { r: 70 },
    ".": { r: 700 },
    ",": { r: 500 },
    ":": { r: 500 },
    ";": { r: 400 },
    "!": { r: 100 },
    "?": { r: 200 },
    "~": { l: 300, r: 350 },
    "&": { r: 100 },
    "%": { l: 50, r: 100 },
    "*": { l: 200, r: 200 },
    "+": { l: 250, r: 300 },
    "=": { l: 200, r: 200 },
    "(": { l: 200 },
    ")": { r: 200 },
    "/": { l: 100, r: 300 },
    "-": { l: 500, r: 600 },
    "–": { l: 250, r: 300 },
    "—": { l: 250, r: 250 },
    "‘": { l: 300, r: 600 },
    "’": { l: 300, r: 600 },
    "“": { l: 400, r: 400 },
    "”": { l: 400, r: 400 },
    "_": { l: 100, r: 200 },
    "\\": { l: 100, r: 300 },
    "|": { l: 200, r: 200 },
    "‚": { l: 400, r: 400 },
    "„": { l: 400, r: 400 },
    "‹": { l: 400, r: 400 },
    "›": { l: 300, r: 600 },
    "«": { l: 300, r: 400 },
    "»": { l: 300, r: 400 },
    "¡": { l: 100 },
    "¿": { l: 100 },
    "{": { l: 400, r: 200 },
    "}": { l: 200, r: 400 },
    "<": { l: 200, r: 100 },
    ">": { l: 100, r: 200 },
  },
};

/** First CSS family name → microtype config id. Includes metric clones. */
const FAMILY_TO_TABLE: Record<string, string> = {
  "eb garamond": "ebg",
  "palatino": "ppl",
  "palatino linotype": "ppl",
  "urw palladio l": "ppl",
  "tex gyre pagella": "ppl",
  "book antiqua": "ppl",
  "times": "ptm",
  "times new roman": "ptm",
  "liberation serif": "ptm",
  "tex gyre termes": "ptm",
  "nimbus roman": "ptm",
  "nimbus roman no9 l": "ptm",
  "charter": "bch",
  "bitstream charter": "bch",
  "charter bt": "bch",
  "xcharter": "bch",
  "minion": "pmn",
  "minion pro": "pmn",
  "minion 3": "pmn",
  "urw garamond": "ugm",
  "garamond no 8": "ugm",
  "garamondno8": "ugm",
  "garamond": "ugm",
};

/**
 * The hand-tuned microtype protrusion table for a font, looked up by the
 * first family in a CSS font-family list, or undefined when no config
 * exists for it. Merge order in the DOM layer: generic table, then this,
 * then user overrides.
 */
export function fontProtrusion(familyList: string): ProtrusionTable | undefined {
  const first = familyList.split(',')[0]!.trim().replace(/^["']+|["']+$/g, '').toLowerCase();
  const id = FAMILY_TO_TABLE[first];
  return id === undefined ? undefined : TABLES[id];
}
